export const PageHeader = ({ eyebrow, title, children, testId }) => (
  <div className="mb-8 rise" data-testid={testId}>
    {eyebrow && <p className="text-xs uppercase tracking-widest font-semibold text-amber-800/80">{eyebrow}</p>}
    <h1 className="mt-1 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-amber-950">{title}</h1>
    {children && <div className="mt-3 max-w-3xl text-sm sm:text-base text-stone-600 leading-relaxed">{children}</div>}
  </div>
);
